module.exports = __webpack_public_path__ + "img/honor_bg1.63529058.png";